import axios from "./axios-auth";

const getAllSystemUsers = (data) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getsystemusers",
      params: {},
      data: data,
      method: "POST",
    })
      .then((resp) => {
        console.log(resp, "resp from getAllSystemUsers api");
        resolve(resp);
      })
      .catch(() => {
        console.log("error from from getAllSystemUsers api");
      });
  });

const getSystemUserById = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getsystemuserdetails",
      params: params,
      method: "GET",
    })
      .then((resp) => {
        console.log(resp, "from get system user by id api");
        resolve(resp);
      })
      .catch(() => {
        console.log("from get system user by id api");
      });
  });

const insertSystemUser = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/addsystemuser",
      data: params,
      method: "POST",
    })
      .then((resp) => {
        console.log(resp, " from insert system user api");
        resolve(resp);
      })
      .catch((err) => {
        console.log(err, "from insert system user api");
      });
  });

const editSystemUser = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/updatesystemuser",
      data: params,
      method: "PUT",
    })
      .then((resp) => {
        console.log(resp, " from edit system user api");
        resolve(resp);
      })
      .catch((err) => {
        console.log(err, "from edit system user api");
      });
  });

const deleteSystemUser = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/deletesystemuserbyid",
      params: params,
      method: "DELETE",
    })
      .then((resp) => {
        console.log(resp, " from delete user api");
        resolve(resp.data);
      })
      .catch((err) => {
        console.log(err, "from delete user api");
      });
  });

  const getAllSecurityRoles = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getsecurityroles",
      params: params,
      method: "GET",
    })
      .then((resp) => {
        console.log(resp, "from getAllSecurityRoles api");
        resolve(resp);
      })
      .catch(() => {
        console.log("from getAllSecurityRoles api");
      });
  });

export {
  insertSystemUser,
  editSystemUser,
  getSystemUserById,
  getAllSystemUsers,
  deleteSystemUser,
  getAllSecurityRoles
};
